import { Button, Dialog, DialogActions, DialogContent } from '@material-ui/core';
import ChatIcon from '@mui/icons-material/Chat';
import MergeIcon from '@mui/icons-material/Merge';
import React, { useState } from 'react';

const SubtitleIconLeftColumn = ({ index, rowData, updateSubIndex, mergeSub }) => {
    const [isCommentBoxOpen, setCommentBoxOpen] = useState(false);
    const [commentText, setCommentText] = useState('');
    const [anchorIndex, setAnchorIndex] = useState(null);

    const handleCommentBoxClose = () => {
        setCommentBoxOpen(false);
    };

    return (
        <div
            id={`commentDivIcon${index}`}
            style={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-evenly',
                width: '30px',
            }}
        >
            <ChatIcon
                id={`commentIcon${index}`}
                style={{
                    fontSize: '19px',
                    marginRight: '10px',
                    cursor: 'pointer',
                    color: rowData?.note ? 'green' : null,
                }}
                onClick={() => {
                    setCommentBoxOpen(true);
                    setCommentText(rowData?.note);
                    setAnchorIndex(index);
                }}
            />

            <Dialog
                id={`commentDialog${index}`}
                BackdropProps={{
                    style: { opacity: 0.1 },
                }}
                open={isCommentBoxOpen}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogContent>
                    <textarea
                        id={`commentTextInput${index}`}
                        placeholder={'Enter a comment.'}
                        style={{ minWidth: '300px', minHeight: '100px' }}
                        defaultValue={commentText ?? ''}
                        onChange={(e) => setCommentText(e.target.value)}
                    />
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCommentBoxClose}>Cancel</Button>
                    <Button
                        onClick={() => {
                            updateSubIndex(rowData, { note: commentText }, anchorIndex);
                            handleCommentBoxClose();
                        }}
                    >
                        Save
                    </Button>
                </DialogActions>
            </Dialog>

            <MergeIcon
                id={`mergeIcon${index}`}
                style={{ fontSize: '19px', marginRight: '10px', cursor: 'pointer' }}
                onClick={() => mergeSub(rowData)}
            />
        </div>
    );
};

export default SubtitleIconLeftColumn;
